
// prettier-ignore
/* eslint-disable linebreak-style */
/* eslint-disable no-useless-escape */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable max-len */
/* eslint-disable no-trailing-spaces */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */

// import React from "react";

// import { Fade } from "react-awesome-reveal";
// eslint-disable-next-line import/no-extraneous-dependencies
// import * as emailjs from "@emailjs/browser";
// eslint-disable-next-line import/no-extraneous-dependencies
// import { ToastContainer, toast } from "react-toastify";
// eslint-disable-next-line import/no-extraneous-dependencies
// import "react-toastify/dist/ReactToastify.css";

// import { Form } from "elements/Form";
// import Button from "elements/Button";

// export const DiscussForm = (actions) => {
//   const { data, resetForm } = actions;
//   const submitEmail = () => {
//     const { name, company, email, phone, projectIdea } = data;

//     const templateParams = {
//       from_name: `${name} - ${company} ( ${phone} - ${email} )`,
//       to_name: "LetMeCast & Production Co.",
//       message: projectIdea,
//       phone, 
//       name,
//       company,
//     };
    /* eslint-disable operator-linebreak */

//     if (
//       name !== "" &&
//       company !== "" &&
//       email !== "" &&
//       phone !== "" &&
//       projectIdea !== ""
//     ) {
//       emailjs
//         .send(
//           "service_k59iflw",
//           "template_k4a6t2d",
//           templateParams,
//           "df7ua6lyYmlJ2Xd0X",
//         )
//         .then(
//           () => {
//             toast.success("Success! we'll get back to you soon. Thank you!");
//             resetForm();
//           },
//           (error) => {
//             toast.error(error);
//           },
//         );
//     } else {
//       toast.error("Please fill out the blank form.");
//     }
//   };

//   return (
//     <section className="flex flex-col container mx-auto mt-10 justify-center">
//       <Fade direction="down" triggerOnce>
//         <h1 className="text-5xl text-black text-center font-bold">
//           Lets Discuss
//         </h1>
//       </Fade>

//       <Fade direction="up" triggerOnce>
//         <p className="font-light text-lg text-gray-600 text-center mb-12">
//           {/* eslint-disable-next-line react/no-unescaped-entities */}
//           Please fill out the form below to discuss your project and we'll get
//           back to you in less than 24 hours.
//         </p>
//       </Fade>

//       <Fade direction="up" triggerOnce>
//         <div className="flex flex-col">
//           <div className="flex flex-col sm:flex-row mx-auto">
//             <Form
//               id="name"
//               name="name"
//               type="text"
//               value={data.name}
//               placeholder="Your name"
//               className=""
//               onChange={actions.onChange}
//             />
//             <Form
//               id="company"
//               name="company"
//               type="text"
//               value={data.company}
//               placeholder="Your company"
//               className=""
//               onChange={actions.onChange}
//             />
//           </div>

//           <div className="flex flex-col sm:flex-row mx-auto">
//             <Form
//               id="email"
//               name="email"
//               type="email"
//               value={data.email}
//               placeholder="Your email address"
//               className=""
//               onChange={actions.onChange}
//             />
//             <Form
//               id="phone"
//               name="phone"
//               type="number"
//               value={data.phone}
//               placeholder="Your contact number"
//               className=""
//               onChange={actions.onChange}
//             />
//           </div>

//           <div className="mx-auto">
//             <Form
//               id="projectIdea"
//               name="projectIdea"
//               type="textarea"
//               value={data.projectIdea}
//               placeholder="Explain about your project idea"
//               className=""
//               onChange={actions.onChange}
//             />
//           </div>
//           <Button
//             className="text-xl mx-auto px-12 py-3 mt-5 bg-[#D4AF37] text-white rounded-full border-2 border-black hover:bg-black border-purple-800 transition duration-200 focus:outline-none"
//             type="button"
//             onClick={submitEmail}
//           >
//             Submit
//           </Button>
//         </div>
//       </Fade>

//       <ToastContainer />
//     </section>
//   );
// };
import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const DiscussForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const submitEmail = async (e) => {
    console.log("📤 Sending request:", formData);

    e.preventDefault(); // Prevent form from submitting by default
  
    const { name, email, phone, message } = formData;
  
    // Check if any field is empty
    if (!name.trim() || !email.trim() || !phone.trim() || !message.trim()) {
      toast.error("All fields are required!");
      return; // Stop submission if validation fails
    }
  
    try {
      const response = await fetch("https://letmecast-backend.onrender.com/send-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, phone, message }),
      });
  
      if (response.ok) {
        toast.success("Success! We will get back to you soon.");
        setFormData({ name: "", email: "", phone: "", message: "" }); // Reset form
      } else {
        toast.error("Failed to send email. Please try again.");
      }
    } catch (error) {
      // eslint-disable-next-line
      console.error("Error:", error);
      toast.error("Error sending email.");
    }
  };
  

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-bold text-center">Contact Us</h1>
      <p className="text-center text-gray-600">Fill out the form below and we will get back to you.</p>
      <form onSubmit={submitEmail} className="flex flex-col space-y-4 mt-6">
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Your Name"
          className="p-2 border rounded"
          required
        />
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="Your Email"
          className="p-2 border rounded"
          required
        />
        <input
          type="text"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          placeholder="Your Phone"
          className="p-2 border rounded"
          required
        />
        {/* eslint-disable-next-line react/self-closing-comp */}
        <textarea 
        name="message" 
        value={formData.message} 
        onChange={handleChange} 
        placeholder="Your Message" 
        className="p-2 border rounded h-24" 
        required
        >

        </textarea>

        <button type="submit" className="bg-[#D4AF37] text-white p-2 rounded border-2 border-black hover:bg-black border-black transition duration-200">Submit</button>
      </form>

      <ToastContainer />
    </div>
    
  );
};
